import React from 'react'

import { Table } from 'antd'
import { DOC_REVIEW_DASHBOARD_PATH } from 'docReviewDashboard'
import { EXPENSES_PATH } from 'docReviewDashboard/Expenses'
import ExpenseReviewIcon from 'docReviewDashboard/common/ExpenseReviewStatusIcon'

import OrderedPageFilter from 'core/application/commons/orderedPageFilter'
import { ExpenseAttachment } from 'core/application/docReviewDashboard/expenses/expenseAttachment'
import { PagedExpenses } from 'core/application/docReviewDashboard/searchExpenses/searchExpenses'

import { parseZoneFormat } from 'common/dateFormatters'

interface ExpensesTableProps {
  setSearchFilter: (value: OrderedPageFilter) => void
  expenses: PagedExpenses
  loadingExpenses: boolean
  history: any
  translate: (key: string) => string
  setViewAttachments: () => void
  setActiveModalAttachments: (attachments: ExpenseAttachment[]) => void
}

const ExpensesTable: React.FC<ExpensesTableProps> = ({
  setSearchFilter,
  expenses,
  loadingExpenses,
  history,
  translate,
  setViewAttachments,
  setActiveModalAttachments,
}) => {
  const columns = [
    {
      title: translate('doc-review-dashboard.search-expenses.expense-id'),
      dataIndex: 'expenseNumber',
      key: 'expenseNumber',
      sorter: false,
      render: (text: string, record: any) => {
        return (
          <span>
            <div>
              <a onClick={() => history.push(`${DOC_REVIEW_DASHBOARD_PATH}/${EXPENSES_PATH}/${record.id}`)}>
                {record.expenseNumber}
              </a>
            </div>
          </span>
        )
      },
    },
    {
      title: translate('doc-review-dashboard.search-expenses.last-modified'),
      dataIndex: 'lastModifiedAt',
      key: 'lastModifiedAt',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <p>{parseZoneFormat(record.lastModifiedAt)}</p>
          </div>
        </span>
      ),
    },
    {
      title: translate('doc-review-dashboard.search-expenses.full-name'),
      dataIndex: 'fullName',
      key: 'fullName',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <p>{record.fullName}</p>
          </div>
        </span>
      ),
    },
    {
      title: translate('doc-review-dashboard.search-expenses.company'),
      dataIndex: 'companyName',
      key: 'companyName',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <p>{record.companyName}</p>
          </div>
        </span>
      ),
    },
    {
      title: translate('doc-review-dashboard.search-expenses.email'),
      dataIndex: 'email',
      key: 'email',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <p>{record.email}</p>
          </div>
        </span>
      ),
    },
    {
      title: translate('doc-review-dashboard.search-expenses.status'),
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <p>
              <ExpenseReviewIcon status={record.status} />
            </p>
          </div>
        </span>
      ),
    },
    {
      title: translate('doc-review-dashboard.search-expenses.expense-amount'),
      dataIndex: 'amount',
      key: 'amount',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <p>${record.amount}</p>
          </div>
        </span>
      ),
    },
    {
      title: translate('doc-review-dashboard.search-expenses.actions'),
      dataIndex: '',
      key: '',
      sorter: false,
      render: (text: string, record: any) => (
        <span>
          <div className="reimburse_row">
            <span
              className="color-blue-6 cursor_pointer"
              onClick={() => {
                setActiveModalAttachments(record.attachments)
                setViewAttachments()
              }}
            >
              {translate('general.view')}
            </span>
          </div>
        </span>
      ),
    },
  ]

  const onExpensesTableChange = (pagination: any, filters: any, sorter: any) => {
    setSearchFilter({
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
      orderColumn: sorter.field || 'createdAt',
      orderDescending: sorter.order !== 'ascend',
    })
  }

  return (
    <Table
      dataSource={expenses.items}
      onChange={onExpensesTableChange}
      loading={loadingExpenses}
      columns={columns}
      pagination={{
        total: expenses.totalItemCount,
        pageSize: expenses.pageSize,
        current: expenses.pageNumber,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40'],
      }}
    />
  )
}

export default ExpensesTable
